module.exports = __webpack_public_path__ + "img/sendd.9f5bd8fb.png";